import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {Format} from '../message/Format';
import {FormatCriteria} from './FormatCriteria';

export class FormatWrapper extends BaseWrapper<Format, FormatCriteria, BasicScenario>  {}

